import type { MessageFile } from 'lib-shared-types-api';

type ConversationMessageAttachmentsProps = {
  attachments: readonly MessageFile[];
};

/** Represents the conversation message attachments component. */
// TODO: [TEAMS-10722] Implement attachments component
export const ConversationMessageAttachments = ({
  attachments,
}: ConversationMessageAttachmentsProps): JSX.Element => {
  return <></>;
};
